@if (!hasChildren) {
  <li>
    <a class="sidebar-item" role="menuitem" tabindex="-1" [routerLink]="url" routerLinkActive="active">{{ label }} </a>
  </li>
}
@if (hasChildren) {
  <li rtChildRouterLinkActive rtAccordion>
    <span class="sidebar-item" role="separator" rtAccordionToggle>
      <span>{{ label }}</span>
    </span>
    <ul rtAccordionContent>
      <ng-content> </ng-content>
    </ul>
  </li>
}
